import React from 'react';

import  Avidreader1to82024  from 'views/Avidreader1to82024';

const DesktopAppPage = () => {
  return <Avidreader1to82024 />;
};

export default DesktopAppPage;
